"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = exports.SubHeader = exports.PageHeader = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dedupe = _interopRequireDefault(require("classnames/dedupe"));

var _RequiredInstructions = require("./RequiredInstructions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageHeader = function PageHeader(_ref) {
  var heading = _ref.heading;
  return _react.default.createElement("h2", {
    className: "page-header"
  }, _react.default.createElement("span", null, heading));
};

exports.PageHeader = PageHeader;
PageHeader.propTypes = {
  heading: _propTypes.default.string.isRequired
};

var SubHeader = function SubHeader(_ref2) {
  var heading = _ref2.heading;
  return _react.default.createElement("h3", {
    className: "page-sub-header"
  }, _react.default.createElement("span", null, heading));
};

exports.SubHeader = SubHeader;
SubHeader.propTypes = {
  heading: _propTypes.default.string.isRequired
};

var Container = function Container(_ref3) {
  var children = _ref3.children,
      hasSlimPadding = _ref3.hasSlimPadding,
      hasNoPadding = _ref3.hasNoPadding,
      heading = _ref3.heading,
      hide = _ref3.hide,
      showRequiredMsg = _ref3.showRequiredMsg,
      requiredMsg = _ref3.requiredMsg,
      customClassName = _ref3.customClassName;
  var cssClass = (0, _dedupe.default)('container', {
    'container--hidden': hide,
    'container--slim-padding': hasSlimPadding,
    'container--no-padding': hasNoPadding
  }, customClassName);
  var hasDefaultHeading = !!heading;
  return _react.default.createElement("div", {
    className: cssClass
  }, showRequiredMsg && requiredMsg && _react.default.createElement(_RequiredInstructions.RequiredInstructions, {
    text: requiredMsg
  }), hasDefaultHeading && _react.default.createElement(PageHeader, {
    heading: heading
  }), children);
};

exports.Container = Container;
Container.defaultProps = {
  heading: null,
  hasSlimPadding: false,
  hasNoPadding: false,
  hide: false,
  showRequiredMsg: false,
  requiredMsg: null,
  customClassName: null
};
Container.propTypes = {
  children: _propTypes.default.node.isRequired,
  hasSlimPadding: _propTypes.default.bool,
  hasNoPadding: _propTypes.default.bool,
  heading: _propTypes.default.string,
  hide: _propTypes.default.bool,
  showRequiredMsg: _propTypes.default.bool,
  requiredMsg: _propTypes.default.string,
  customClassName: _propTypes.default.string
};